<template>
  <div class="templates-content">
    <TodoModal
      v-model="editModal"
      :edit-item="templateToEdit"
      from-page="templates"
      @updated-todo="templateUpdated"
      @delete="deleteTemplate(templateToEdit.id)"
    />

    <SingleTask
      v-for="template of templates"
      :key="template.id"
      :task="template"
      @click.native="editTemplateClicked(template)"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { cloneDeep } from 'lodash'
// Components
import SingleTask from '../../kanban-board/components/SingleTask'
import TodoModal from '@/reusable/TodoModal/TodoModal'

export default {
  components: {
    SingleTask,
    TodoModal
  },

  data: () => ({
    editModal: false,
    templateToEdit: null
  }),

  computed: {
    ...mapState('todo-templates', ['templates'])
  },

  async created() {
    this.$emit('loading', true)
    await this.getAndSetTemplates()
    this.$emit('loading', false)
    const cards = this.$el.querySelectorAll('.single-task')
    cards.forEach((el, index) => {
      el.style.animationDelay = `${(index + 1) * 50}ms`
    })
  },

  methods: {
    ...mapActions('todo-templates', ['getAndSetTemplates', 'deleteTemplate']),
    ...mapMutations('todo-templates', ['templateUpdated']),

    editTemplateClicked(template) {
      this.templateToEdit = cloneDeep(template)
      this.editModal = true
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/mixins'

sequentialLoadAnimation()

.templates-content {
  display grid
  grid-template-columns repeat(auto-fit, minmax(250px, 320px))
  align-items start
  gap 10px

  > .single-task {
    animation fadeInScaleIn 350ms ease-in-out both;

    &:hover {
      box-shadow 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px rgba(0,0,0,0.14), 0 1px 10px rgba(0,0,0,0.12)
    }
  }

  > .single-task:last-child {
    margin-bottom 15px //https://github.com/w3c/csswg-drafts/issues/129
  }
}
</style>
